import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import InstitutionDashboard from "./components/InstitutionDashboard";
import Header from "./components/Header";

function App() {
  return (
    <BrowserRouter>
      <div className="min-h-screen flex flex-col">
        <Header />
        <div className="flex-1">
          <Routes>
            <Route path="/custom/:name/*" element={<InstitutionDashboard />} />
            <Route path="/:id/*" element={<InstitutionDashboard />} />
            <Route
              path="/"
              element={
                <div className="min-h-screen bg-gradient-to-br from-slate-50 to-blue-50 flex items-center justify-center">
                  <div className="text-center">
                    <h1 className="text-2xl font-bold text-gray-800 mb-2">
                      AI Coaching Dashboard
                    </h1>
                    <p className="text-gray-600">
                      Please provide an institution ID in the URL
                    </p>
                  </div>
                </div>
              }
            />
          </Routes>
        </div>
      </div>
    </BrowserRouter>
  );
}

export default App;
